import "@splidejs/splide/dist/css/themes/splide-default.min.css";
import Splide from "@splidejs/splide";

const hasSplideMarkup = (gallery) =>
  gallery.querySelector(".splide__track") &&
  gallery.querySelector(".splide__list") &&
  gallery.querySelector(".splide__slide");

const splideOnePerPage = [...document.querySelectorAll(".splide-1-per-page")];

if (splideOnePerPage.length > 0) {
  splideOnePerPage.forEach(function (gallery) {
    if (!hasSplideMarkup(gallery)) {
      return;
    }

    var splide = new Splide(gallery, {
      type: "loop",
      arrows: false,
      pagination: true,
      perPage: 1,
      perMove: 1,
      speed: 300,
      drag: true,
      updateOnMove: true,
    });

    splide.mount();
  });
}

const splideLeftOnePerPage = [
  ...document.querySelectorAll(".splide-1-per-page-left"),
];

if (splideLeftOnePerPage.length > 0) {
  splideLeftOnePerPage.forEach(function (gallery) {
    if (!hasSplideMarkup(gallery)) {
      return;
    }

    var splide = new Splide(gallery, {
      type: "loop",
      arrows: true,
      pagination: true,
      arrowPath:
        "M9.98866655,36.2238927 C9.17619161,37.0370499 9.17619161,38.3600715 9.98866655,39.1731166 C10.3823458,39.5670721 10.9057563,39.7838542 11.4624687,39.7838542 C12.0191811,39.7838542 12.5422553,39.5668477 12.9357103,39.1732288 L30.8380787,21.25841 C31.2315337,20.8644546 31.4482759,20.3406767 31.4482759,19.7836859 C31.4482759,19.226695 31.2314215,18.7030293 30.8380787,18.3092983 L12.9360467,0.394479519 C12.5424796,0.000748471368 12.019069,-0.216145833 11.4623566,-0.216145833 C10.9057563,-0.216145833 10.3823458,0.000860677423 9.98866655,0.394479519 C9.17630374,1.2076368 9.17630374,2.5306584 9.98877868,3.34381568 L24.7965437,18.1621962 C26.0610041,19.4117228 26.0016887,20.1994093 24.7966559,21.4052878 L9.98866655,36.2238927 Z",

      perPage: 1,
      perMove: 1,
      speed: 300,
      drag: true,
      breakpoints: {
        768: {
          arrows: false,
          pagination: true,
        },
      },
      updateOnMove: true,
    });

    splide.mount();
  });
}

const splideLeftOnePerPageCustom = [
  ...document.querySelectorAll(".splide-1-per-page-left-custom"),
];

if (splideLeftOnePerPageCustom.length > 0) {
  splideLeftOnePerPageCustom.forEach(function (gallery) {
    if (!hasSplideMarkup(gallery)) {
      return;
    }

    var splide = new Splide(gallery, {
      type: "loop",
      arrows: true,
      pagination: false,
      arrowPath:
        "M9.98866655,36.2238927 C9.17619161,37.0370499 9.17619161,38.3600715 9.98866655,39.1731166 C10.3823458,39.5670721 10.9057563,39.7838542 11.4624687,39.7838542 C12.0191811,39.7838542 12.5422553,39.5668477 12.9357103,39.1732288 L30.8380787,21.25841 C31.2315337,20.8644546 31.4482759,20.3406767 31.4482759,19.7836859 C31.4482759,19.226695 31.2314215,18.7030293 30.8380787,18.3092983 L12.9360467,0.394479519 C12.5424796,0.000748471368 12.019069,-0.216145833 11.4623566,-0.216145833 C10.9057563,-0.216145833 10.3823458,0.000860677423 9.98866655,0.394479519 C9.17630374,1.2076368 9.17630374,2.5306584 9.98877868,3.34381568 L24.7965437,18.1621962 C26.0610041,19.4117228 26.0016887,20.1994093 24.7966559,21.4052878 L9.98866655,36.2238927 Z",
      perPage: 1,
      perMove: 1,
      speed: 300,
      drag: true,
      breakpoints: {
        768: {
          arrows: true,
          pagination: false,
        },
      },
      updateOnMove: true,
    });

    splide.mount();
  });
}

const uniqueGalleries = document.querySelectorAll(".splide-slider-unique");

uniqueGalleries &&
  uniqueGalleries.forEach((gallery) => {
    if (!hasSplideMarkup(gallery)) {
      return;
    }

    const perPage = parseInt(gallery.getAttribute("data-per-page"), 10) || 4;

    if (!gallery.classList.contains("splide-initialized")) {
      new Splide(gallery, {
        type: "loop",
        arrows: true,
        pagination: false,
        perPage: perPage,
        perMove: 1,
        gap: "16px",
        autoplay: false,
        drag: true,
        arrowPath:
          "M9.98866655,36.2238927 C9.17619161,37.0370499 9.17619161,38.3600715 9.98866655,39.1731166 C10.3823458,39.5670721 10.9057563,39.7838542 11.4624687,39.7838542 C12.0191811,39.7838542 12.5422553,39.5668477 12.9357103,39.1732288 L30.8380787,21.25841 C31.2315337,20.8644546 31.4482759,20.3406767 31.4482759,19.7836859 C31.4482759,19.226695 31.2314215,18.7030293 30.8380787,18.3092983 L12.9360467,0.394479519 C12.5424796,0.000748471368 12.019069,-0.216145833 11.4623566,-0.216145833 C10.9057563,-0.216145833 10.3823458,0.000860677423 9.98866655,0.394479519 C9.17630374,1.2076368 9.17630374,2.5306584 9.98877868,3.34381568 L24.7965437,18.1621962 C26.0610041,19.4117228 26.0016887,20.1994093 24.7966559,21.4052878 L9.98866655,36.2238927 Z",

        breakpoints: {
          768: {
            perPage: 2,
          },
        },
      }).mount();

      gallery.classList.add("splide-initialized");
    }
  });

const simpleGalleries = [...document.querySelectorAll(".splide-slider-simple")];

if (simpleGalleries.length > 0) {
  simpleGalleries.forEach((gallery) => {
    if (!hasSplideMarkup(gallery)) {
      return;
    }

    const perPage = parseInt(gallery.getAttribute("data-per-page"), 10) || 4;

    if (!gallery.classList.contains("splide-initialized")) {
      new Splide(gallery, {
        type: "loop",
        arrows: true,
        pagination: false,
        perPage: perPage,
        perMove: 1,
        gap: "16px",
        autoplay: false,
        drag: true,
        arrowPath:
          "M9.98866655,36.2238927 C9.17619161,37.0370499 9.17619161,38.3600715 9.98866655,39.1731166 C10.3823458,39.5670721 10.9057563,39.7838542 11.4624687,39.7838542 C12.0191811,39.7838542 12.5422553,39.5668477 12.9357103,39.1732288 L30.8380787,21.25841 C31.2315337,20.8644546 31.4482759,20.3406767 31.4482759,19.7836859 C31.4482759,19.226695 31.2314215,18.7030293 30.8380787,18.3092983 L12.9360467,0.394479519 C12.5424796,0.000748471368 12.019069,-0.216145833 11.4623566,-0.216145833 C10.9057563,-0.216145833 10.3823458,0.000860677423 9.98866655,0.394479519 C9.17630374,1.2076368 9.17630374,2.5306584 9.98877868,3.34381568 L24.7965437,18.1621962 C26.0610041,19.4117228 26.0016887,20.1994093 24.7966559,21.4052878 L9.98866655,36.2238927 Z",

        breakpoints: {
          768: {
            perPage: 2,
          },
        },
      }).mount();

      gallery.classList.add("splide-initialized");
    }
  });
}

const simpleGalleriesTags = [
  ...document.querySelectorAll(".splide-slider-simple-tags"),
];

if (simpleGalleriesTags.length > 0) {
  simpleGalleriesTags.forEach((gallery) => {
    if (!hasSplideMarkup(gallery)) {
      return;
    }

    if (!gallery.classList.contains("splide-initialized")) {
      new Splide(gallery, {
        type: "loop",
        arrows: false,
        pagination: false,
        perPage: "auto",
        perMove: 1,
        gap: "8px",
        autoplay: false,
        drag: true,
        arrowPath:
          "M9.98866655,36.2238927 C9.17619161,37.0370499 9.17619161,38.3600715 9.98866655,39.1731166 C10.3823458,39.5670721 10.9057563,39.7838542 11.4624687,39.7838542 C12.0191811,39.7838542 12.5422553,39.5668477 12.9357103,39.1732288 L30.8380787,21.25841 C31.2315337,20.8644546 31.4482759,20.3406767 31.4482759,19.7836859 C31.4482759,19.226695 31.2314215,18.7030293 30.8380787,18.3092983 L12.9360467,0.394479519 C12.5424796,0.000748471368 12.019069,-0.216145833 11.4623566,-0.216145833 C10.9057563,-0.216145833 10.3823458,0.000860677423 9.98866655,0.394479519 C9.17630374,1.2076368 9.17630374,2.5306584 9.98877868,3.34381568 L24.7965437,18.1621962 C26.0610041,19.4117228 26.0016887,20.1994093 24.7966559,21.4052878 L9.98866655,36.2238927 Z",

        breakpoints: {
          768: {
            perPage: 2,
          },
        },
      }).mount();

      gallery.classList.add("splide-initialized");
    }
  });
}
